<template>
  <div class="wapper">
    <el-container style="100%">
      <el-main style="background: #fff">
        <div class="table-wrap" v-show="listShow">
          <div class="handle-box3">
            <el-form
                :inline="true"
                ref="form"
                :model="searchForm"
                class="demo-form-inline handle-search"
            >
              <div class="uers-left">
                <el-form-item label="搜索：">
                  <el-input
                      v-model="searchForm.name"
                      placeholder="名称"
                  ></el-input>
                </el-form-item>
                <el-form-item label="">
                  <el-input
                      v-model="searchForm.code"
                      placeholder="码值"
                  ></el-input>
                </el-form-item>
                <el-form-item label="票类型：">
                  <el-select v-model="ticketTypeId" placeholder="选择票类型">
                    <el-option
                        v-for="(type, index) in TicketType"
                        :label="type.name"
                        :key="index"
                        :value="type.ticketTypeId"
                    >
                      <div @click="getChangeType(type)">{{ type.name }}</div>
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="证件类型：">
                  <el-select
                      v-model="documentTypeId"
                      placeholder="选择证件类型"
                  >
                    <el-option
                        v-for="(type, index) in DocumentType"
                        :label="type.name"
                        :key="index"
                        :value="type.documentTypeId"
                    >
                      <div @click="getChangeDocuType(type)">
                        {{ type.name }}
                      </div>
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-button
                    type="primary"
                    icon="el-icon-search"
                    @click="searchSubmit()"
                >搜索
                </el-button
                >
              </div>
              <div class="uers-right">
                <span class="btn-r">
                  <el-button
                      type="primary"
                      plain
                      icon="el-icon-plus"
                      @click="addSubmit"
                  >新增</el-button
                  >
                  <el-button
                      type="primary"
                      plain
                      icon="el-icon-plus"
                      @click="addProject"
                  >项目新增头像</el-button
                  >
                  <el-button
                      type="primary"
                      plain
                      icon="el-icon-delete"
                      @click="clearAll"
                  >清空</el-button
                  >
                </span>
              </div>
            </el-form>
          </div>
          <div class="tabbox">
            <el-table
                :data="dataList"
                height="100%"
                border
                class="tabbox"
                ref="multipleTable"
                :header-cell-style="{ background: '#f2f6fc', color: '#606266' }"
                @selection-change="handleSelectionChange"
            >
              <el-table-column
                  type="selection"
                  width="55"
                  align="center"
              ></el-table-column>
              <el-table-column prop="code" label="码值" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.row.code }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="name" label="名称" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.row.name }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="name" label="公司" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.row.company }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="name" label="职务" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.row.position }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="name" label="备注" align="center">
                <template slot-scope="scope">
                  <span>{{ scope.row.remark }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="url" label="头像" align="center">
                <template slot-scope="scope">
                  <div class="demo-image__preview">
                    <el-image
                        style="width: 40px; height: 40px"
                        :preview-src-list="[scope.row.url]"
                        :src="scope.row.url"
                    ></el-image>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                  prop="createDate"
                  label="创建时间"
                  align="center"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.createDate }}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <el-button
                      type="text"
                      @click="handleEdit(scope.$index, scope.row)"
                  >编辑
                  </el-button
                  >
                  <el-button
                      type="text"
                      class="red"
                      @click="handleDelete(scope.$index, scope.row)"
                  >删除
                  </el-button
                  >
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="fb">
            <el-pagination
                class="pag"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page="currentPage"
                :page-sizes="[5, 10, 15, 20, 50, 100]"
                :page-size="pagesize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total"
                background
            ></el-pagination>
          </div>
        </div>
        <DeleteDialog
            :delVisible="delVisible"
            @deleteData="deleteData"
            @handleCloseVisible="handleCloseVisible"
        ></DeleteDialog>
        <EditHeadManage
            :editShow="editShow"
            :editData="editData"
            @backFunStu="getFunStu"
        ></EditHeadManage>
      </el-main>
    </el-container>
  </div>
</template>
<script>
import EditHeadManage from "../../../components/ticketing/certificate/EditHeadManage";
import DeleteDialog from "../../../components/public/DeleteConfim";

export default {
  data() {
    return {
      total: 0, //总条数
      currentPage: 1, //初始页
      pagesize: 10, // 每页的数据
      //表格高度适配
      tabheight: "",
      searchForm: {
        name: "",
        code: "",
        ticketTypeId: 0,
        documentTypeId: 0,
      },
      ticketTypeId: "",
      documentTypeId: "",
      editData: {},
      listShow: true,
      editShow: false,
      delVisible: false,
      dataList: [],
      multipleSelection: [],
      TicketType: [],
      DocumentType: [],
      projectId: localStorage.getItem("project_Id"),
      projectAvatar_Id: "",
    };
  },
  mounted() {
    // this.tabheight=(this.$refs.getheight.offsetHeight-165)
  },
  created() {
    this.getData();
    this.getTicketType();
    this.getDocumentType();
  },
  methods: {
    handleSizeChange(val) {
      this.pagesize = val;
      this.searchSubmit();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.searchSubmit();
    },
    addSubmit() {
      this.editData = null;
      this.listShow = false;
      this.editShow = true;
    },
    addProject() {
      if (confirm("是否新增整个项目头像")) {
        this.$axios
            .put(`/ProjectAvatar/Project/${this.projectId}`)
            .then((res) => {
              if (res.data.hasError) {
                this.$message.error(res.data.message);
              } else {
                this.$message.success("操作成功！");
                this.getData();
              }
            });
      }
    },
    clearAll() {
      if (confirm("是否清除头像")) {
        this.$axios
            .delete(`/ProjectAvatar/project/${this.projectId}`)
            .then((res) => {
              if (res.data.hasError) {
                this.$message.error(res.data.message);
              } else {
                this.$message.success("清除成功！");
                this.getData();
              }
            });
      }
    },
    searchSubmit() {
      var search = {
        name: this.searchForm.name,
        code: this.searchForm.code,
        projectId: this.projectId,
        documentTypeId: this.searchForm.documentTypeId,
        ticketTypeId: this.searchForm.ticketTypeId,
        pageIndex: this.currentPage - 1,
        pageSize: this.pagesize,
      };
      this.$axios.post("/ProjectAvatar/Search", search).then((res) => {
        if (res.data.hasError == false) {
          this.dataList = [...res.data.data];
          this.total = res.data.total;
        }
      });
    },
    handleEdit(index, row) {
      this.editData = row;
      this.listShow = false;
      this.editShow = true;
    },
    handleDelete(index, row) {
      this.projectAvatar_Id = row.projectAvatarId;
      this.delVisible = true;
    },
    handleCloseVisible() {
      this.projectAvatar_Id = "";
      this.delVisible = false;
    },
    deleteData() {
      this.$axios
          .delete(`/ProjectAvatar/${this.projectAvatar_Id}`)
          .then((res) => {
            if (res.data.hasError) {
              this.$message.error(res.data.message);
            } else {
              this.$message.success("删除成功！");
              this.delVisible = false;
              this.getData();
            }
          });
    },
    // 获取数据
    getData() {
      this.currentPage = 1;
      this.searchSubmit();
    },
    getTicketType() {
      this.$axios.get("/TicketType/Project/" + this.projectId).then((res) => {
        if (res.data.hasError == false) {
          this.TicketType = [...res.data.data];
        }
      });
    },
    getDocumentType() {
      this.$axios.get("/DocumentType/Project/" + this.projectId).then((res) => {
        if (res.data.hasError == false) {
          this.DocumentType = [...res.data.data];
        }
      });
    },
    getChangeType(type) {
      this.searchForm.ticketTypeId = type.ticketTypeId;
    },
    getChangeDocuType(type) {
      this.searchForm.documentTypeId = type.documentTypeId;
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    getFunStu() {
      this.listShow = true;
      this.editShow = false;
      this.getData();
    },
  },
  components: {
    EditHeadManage,
    DeleteDialog,
  },
};
</script>
<style lang="scss" scope>
.pag {
  position: absolute;
  bottom: 0;
}

.table-wrap {
  margin-left: 10px;
  height: 100%;
}

.el-main {
  border-radius: 5px;
  position: relative;
}

// .uers-left {
//   float: left;
// }
// .uers-right {
//   float: right;
// }
.handle-search {
  display: flex;
  justify-content: space-between;
}

.el-dialog {
  height: auto;
}
</style>